import { apiClient } from '../../api/client';
import { ENDPOINTS } from '../../api/endpoints';

function unwrap(data: any): any {
  if (data && typeof data === 'object' && 'success' in data && 'data' in data) {
    return data.data;
  }
  return data;
}

export class CustomersService {
  static async list(params?: Record<string, any>): Promise<any[]> {
    const response = await apiClient.get(ENDPOINTS.CUSTOMERS.LIST, { params });
    const unwrapped = unwrap(response.data);
    return Array.isArray(unwrapped) ? unwrapped : [];
  }

  static async getById(id: string | number): Promise<any> {
    const response = await apiClient.get(ENDPOINTS.CUSTOMERS.DETAILS(id));
    return unwrap(response.data);
  }

  static async create(data: any): Promise<any> {
    const response = await apiClient.post(ENDPOINTS.CUSTOMERS.CREATE, data);
    return unwrap(response.data);
  }

  static async update(id: string | number, data: any): Promise<any> {
    const response = await apiClient.put(ENDPOINTS.CUSTOMERS.UPDATE(id), data);
    return unwrap(response.data);
  }

  static async delete(id: string | number): Promise<void> {
    await apiClient.delete(ENDPOINTS.CUSTOMERS.DELETE(id));
  }

  static async getDashboard(id: string | number): Promise<any> {
    const response = await apiClient.get(ENDPOINTS.CUSTOMERS.DASHBOARD(id));
    return unwrap(response.data);
  }
}
